import {
  HTTP_UPDATEBUDGETFA_FETCHING,
  HTTP_UPDATEBUDGETFA_SUCCESS,
  HTTP_UPDATEBUDGETFA_FAILED,
  HTTP_RESET_UPDATEBUDGETFA,
} from "src/Constants";

const initialState = {
  result: null,
  isFeaching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATEBUDGETFA_FETCHING:
      return { ...state, result: null, isFeaching: true, isError: false };
    case HTTP_UPDATEBUDGETFA_SUCCESS:
      return { ...state, result: payload, isFeaching: false, isError: false };
    case HTTP_UPDATEBUDGETFA_FAILED:
      return { ...state, result: null, isFeaching: false, isError: true };
    default:
      return state;
  }
};
